// import Loading from '@/components/Loading';
import React, { useContext } from 'react';
import LoadingML from '@/components/LoadingML';
import { ChartsBoxStyles } from './ChartsBoxStyles';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import NoData from '@/components/no_data_show/NoData';
import { isEmptyObject } from '@/utils/comUtil';

const Body = ({ children, bizData, loading }) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  return (
    <ChartsBoxStyles
      theme={themeContext}
      brand={brandContext}
      style={{ height: 'calc(100% - 30px)' }}
      className="contentBox"
    >
      <LoadingML loading={loading ? 1 : 0}>
        <div className="bodyContent">
          {isEmptyObject(bizData) ? (
            <NoData loading={loading ? 1 : 0} />
          ) : (
            children
          )}
        </div>
      </LoadingML>
    </ChartsBoxStyles>
  );
};

export default Body;
